var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full box"},[_c(_vm.formModule.component,{key:_vm.moduleKey,tag:"component",attrs:{"param":_vm.formModule.param},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }